<loren-trace-dialog
  title="operations.choose_period"
  subtitle="operations.choose_period_sub_title"
  (continue)="continue()">
    <loren-period-selector-form
    [isUsedInDialog]="true"
    (periodChange)="lastSelectedPeriod = $event" />
 </loren-trace-dialog>
